import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiCalendar, FiInfo, FiCheck, FiArrowRight } from 'react-icons/fi';

export const AnnualRenewalIntroPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="py-6">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            {t('labels.lblAnnualRenewal')}
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {t('messages.annualRenewalIntro')}
          </p>
        </div>

        {/* Main Content */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          {/* What is Annual Fee Section */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              {/* <FiInfo className="w-6 h-6 text-blue-600 mr-2" /> */}
              <h2 className="text-xl font-semibold text-gray-900">
                {t('labels.lblWhatIsAnnualFee')}
              </h2>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="space-y-3">
                <p className="text-gray-700 text-sm leading-relaxed">
                  {t('messages.annualFeeDescription')}
                </p>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {t('messages.annualFeeBenefits')}
                </p>
              </div>
              
              <div className="bg-gray-50 rounded-md p-4">
                <h3 className="font-medium text-gray-900 mb-3 text-sm">
                  {t('labels.lblAnnualFeeIncludes')}
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <FiCheck className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700 text-sm">{t('labels.lblAnnualFeeInclude1')}</span>
                  </li>
                  <li className="flex items-start">
                    <FiCheck className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700 text-sm">{t('labels.lblAnnualFeeInclude2')}</span>
                  </li>
                  <li className="flex items-start">
                    <FiCheck className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700 text-sm">{t('labels.lblAnnualFeeInclude3')}</span>
                  </li>
                  <li className="flex items-start">
                    <FiCheck className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-700 text-sm">{t('labels.lblAnnualFeeInclude4')}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Why Important Section */}
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              {t('labels.lblWhyAnnualFeeImportant')}
            </h2>
            
            <div className="grid md:grid-cols-3 gap-4">
              <div className="text-center p-4 bg-white border border-gray-200 rounded-md">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <FiCalendar className="w-5 h-5 text-green-600" />
                </div>
                <h3 className="font-medium text-gray-900 mb-2 text-sm">
                  {t('labels.lblCompliance')}
                </h3>
                <p className="text-gray-600 text-xs">
                  {t('messages.complianceDescription')}
                </p>
              </div>
              
              <div className="text-center p-4 bg-white border border-gray-200 rounded-md">
                <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <FiCheck className="w-5 h-5 text-blue-600" />
                </div>
                <h3 className="font-medium text-gray-900 mb-2 text-sm">
                  {t('labels.lblLegalStatus')}
                </h3>
                <p className="text-gray-600 text-xs">
                  {t('messages.legalStatusDescription')}
                </p>
              </div>
              
              <div className="text-center p-4 bg-white border border-gray-200 rounded-md">
                <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <FiInfo className="w-5 h-5 text-purple-600" />
                </div>
                <h3 className="font-medium text-gray-900 mb-2 text-sm">
                  {t('labels.lblBusinessContinuity')}
                </h3>
                <p className="text-gray-600 text-xs">
                  {t('messages.businessContinuityDescription')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnualRenewalIntroPage; 